import type {
  AdminAccountCostResponse,
  AdminCostMonthResponse,
  AdminUnitPrice,
  AdminUnitPriceRequest,
  AdminUnpricedKey,
} from '@brand24-original/llm-types';
import { client } from '../../apiClient';

export const getCostPrices = async (): Promise<AdminUnitPrice[]> =>
  client(true, true)
    .get<AdminUnitPrice[]>('/admin/costs/prices')
    .then((response) => response.data);

export const addCostPrice = async (price: AdminUnitPriceRequest): Promise<AdminUnitPrice> =>
  client(true, true)
    .post<AdminUnitPrice>('/admin/costs/prices', price)
    .then((response) => response.data);

export const getUnpricedKeys = async (month?: string): Promise<AdminUnpricedKey[]> =>
  client(true, true)
    .get<AdminUnpricedKey[]>('/admin/costs/prices/missing', { params: month ? { month } : {} })
    .then((response) => response.data);

export const getCostMonth = async (month?: string): Promise<AdminCostMonthResponse> =>
  client(true, true)
    .get<AdminCostMonthResponse>('/admin/costs/month', { params: month ? { month } : {} })
    .then((response) => response.data);

export const getAccountCosts = async (accountId: number, month?: string): Promise<AdminAccountCostResponse> =>
  client(true, true)
    .get<AdminAccountCostResponse>(`/admin/costs/account/${accountId}`, { params: month ? { month } : {} })
    .then((response) => response.data);

/** Minor units + ISO currency → "12.34 USD". */
export const formatMoney = (minor: number | null | undefined, currency: string | null | undefined): string =>
  minor === null || minor === undefined || !currency ? '-' : `${(minor / 100).toFixed(2)} ${currency}`;

export const formatUsd = (usd: number | null | undefined): string =>
  usd === null || usd === undefined ? 'no price' : `$${usd.toFixed(2)}`;

/** Current month as YYYY-MM (UTC, like the server). */
export const currentMonth = (): string => new Date().toISOString().slice(0, 7);
